export const defaultMeetingModules = [
  { name: "ZoomFrame", limit: 1 },
  { name: "JitsiFrame", limit: 0 },
  { name: "VonageVideoClientModule", limit: 1, permission: "Vonage", admin: false },
  { name: "Iframe", limit: 0 },
  { name: "Video", limit: 0 },

  { name: "CountdownModule", limit: 0 },
  { name: "Html", limit: 0 },
  { name: "TextModule", limit: 0 },
  { name: "BlockModule", limit: 0 },
  { name: "ButtonModule", limit: 0 },
  { name: "Image", limit: 0 },
  { name: "Connections", limit: 0 },
  { name: "UserCard", limit: 1 },
  { name: "ClientList", limit: 1 },
  { name: "PollModule", limit: 0 },
  { name: "Chat", limit: 1 },
  { name: "GroupGenerator", limit: 1 },
  { name: "SpeakerControl", limit: 1 },
  { name: "Breakouts", limit: 1 },
  { name: "Exhibitors", limit: 0 },
  { name: "Agenda", limit: 1 },
  { name: "Presenter", limit: 1 },
  { name: "ImageMap", limit: 1 },
  { name: "VideoWallModule", limit: 1 },
  { name: "SpeakerCard", limit: 1 },
  { name: "SpeakerList", limit: 1 },
  { name: "EventName", limit: 1 },
  { name: "ContentView", limit: 1 },
  { name: "PlauditButtons", limit: 1 },
  { name: "PlauditTrack", limit: 1 },
];
